/* ============================================================
   Maison Atelier Premium — facets.js
   Filtri, ordinamento, colonne, infinite scroll (AJAX)
   ============================================================ */
(function () {
  'use strict';
  var utils = (window.theme && window.theme.utils) || {};
  var section = document.querySelector('[data-collection-section]');
  if (!section) return;
  var gridWrap = section.querySelector('[data-collection-grid-wrap]');
  var infinite = section.getAttribute('data-infinite') === 'true';
  var mobileDrawer = document.getElementById('FacetsDrawer');
  var controller;
  var requestId = 0;
  var loadingMore = false;
  var observer;
  var selectedCols;

  function filterControls() {
    var controls = Array.from(section.querySelectorAll('[data-facet-input], [data-sort]'));
    if (mobileDrawer && !section.contains(mobileDrawer)) {
      controls = controls.concat(Array.from(mobileDrawer.querySelectorAll('[data-facet-input]')));
    }
    return controls;
  }

  function belongsToSection(element) {
    return section.contains(element) || (mobileDrawer && mobileDrawer.contains(element));
  }

  function syncControls(input) {
    filterControls().forEach(function (control) {
      if (control === input || control.name !== input.name) return;
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (control.value === input.value) control.checked = input.checked;
      } else control.value = input.value;
    });
  }

  function observePagination() {
    if (!observer) return;
    observer.disconnect();
    var pagination = section.querySelector('[data-pagination]');
    if (pagination) observer.observe(pagination);
  }

  function buildURL() {
    var params = new URLSearchParams(window.location.search);
    Array.from(params.keys()).forEach(function (key) {
      if (key === 'page' || key === 'sort_by' || key.indexOf('filter.') === 0) params.delete(key);
    });
    var seen = new Set();
    filterControls().forEach(function (control) {
      if (!control.name || control.disabled || control.value === '') return;
      if ((control.type === 'checkbox' || control.type === 'radio') && !control.checked) return;
      var pair = control.name + '=' + control.value;
      if (seen.has(pair)) return;
      seen.add(pair);
      params.append(control.name, control.value);
    });
    var qs = params.toString();
    return window.location.pathname + (qs ? '?' + qs : '');
  }

  function setLoading(state) { if (gridWrap) gridWrap.classList.toggle('is-loading', state); }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // griglia + paginazione
    var newWrap = doc.querySelector('[data-collection-grid-wrap]');
    if (!newWrap || !gridWrap) throw new Error('Collection unavailable');
    gridWrap.innerHTML = newWrap.innerHTML;
    var grid = section.querySelector('[data-product-grid]');
    if (grid && selectedCols) grid.setAttribute('data-cols', selectedCols);
    // facets desktop
    swapEl(doc, '.facets.facets-drawer');
    // facets mobile
    swapEl(doc, '[data-mobile-facets]');
    // conteggio
    swapEl(doc, '.collection-toolbar__count');
    var sort = section.querySelector('[data-sort]');
    var freshSort = doc.querySelector('[data-sort]');
    if (sort && freshSort) sort.value = freshSort.value;
    observePagination();
    document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: gridWrap } }));
  }

  function swapEl(doc, selector) {
    var fresh = doc.querySelector(selector);
    var current = section.querySelector(selector) || document.querySelector(selector);
    if (fresh && current) current.innerHTML = fresh.innerHTML;
  }

  function render(url, push) {
    if (controller) controller.abort();
    controller = new AbortController();
    var id = ++requestId;
    setLoading(true);
    return fetch(url, { signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Collection unavailable'); return response.text(); })
      .then(function (html) {
        if (id !== requestId) return;
        swap(html);
        if (push !== false) window.history.pushState({ url: url }, '', url);
        if (gridWrap && !(mobileDrawer && mobileDrawer.getAttribute('aria-hidden') === 'false')) {
          gridWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (error) {
        if (error.name !== 'AbortError' && id === requestId) window.location.assign(url);
      })
      .finally(function () { if (id === requestId) setLoading(false); });
  }

  /* cambi sui filtri / sort */
  var debouncedRender = utils.debounce ? utils.debounce(function () { render(buildURL()); }, 350) : function () { render(buildURL()); };
  document.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-facets-form]') || !section.contains(event.target)) return;
    event.preventDefault();
    render(buildURL());
  });
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-facet-input], [data-sort]') && belongsToSection(e.target)) {
      syncControls(e.target);
      var isText = e.target.type === 'number';
      isText ? debouncedRender() : render(buildURL());
    }
  });
  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-facet-input]') && e.target.type === 'number' && belongsToSection(e.target)) { syncControls(e.target); debouncedRender(); }
  });

  /* rimozione chip + paginazione classica */
  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-facet-remove]');
    if (remove && belongsToSection(remove)) { e.preventDefault(); render(remove.getAttribute('href')); return; }
    var pageLink = e.target.closest('[data-pagination] a:not([data-load-more])');
    if (pageLink && section.contains(pageLink) && !infinite) { e.preventDefault(); render(pageLink.getAttribute('href')); return; }
  });

  /* toggle colonne */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cols-set]');
    if (!btn || !section.contains(btn)) return;
    selectedCols = btn.getAttribute('data-cols-set');
    var grid = section.querySelector('[data-product-grid]');
    if (grid) grid.setAttribute('data-cols', btn.getAttribute('data-cols-set'));
    section.querySelectorAll('[data-cols-set]').forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
  });

  /* infinite scroll / load more */
  if (infinite) {
    function loadMore(btn) {
      if (loadingMore || (gridWrap && gridWrap.classList.contains('is-loading'))) return;
      loadingMore = true;
      var id = requestId;
      btn.classList.add('is-loading');
      fetch(btn.getAttribute('href'))
        .then(function (r) { if (!r.ok) throw new Error('Collection unavailable'); return r.text(); })
        .then(function (html) {
          if (id !== requestId) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('[data-product-grid] > .card');
          var grid = section.querySelector('[data-product-grid]');
          if (!grid) return;
          newCards.forEach(function (c) { grid.appendChild(c); });
          var nextBtn = doc.querySelector('[data-load-more]');
          var pag = section.querySelector('[data-pagination]');
          if (pag) pag.innerHTML = nextBtn ? nextBtn.outerHTML : '';
          document.dispatchEvent(new CustomEvent('cards:rendered', { detail: { root: grid } }));
        })
        .catch(function () {})
        .finally(function () { loadingMore = false; btn.classList.remove('is-loading'); if (id !== requestId) observePagination(); });
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (btn && section.contains(btn)) { e.preventDefault(); loadMore(btn); }
    });
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            var btn = section.querySelector('[data-load-more]');
            if (btn) loadMore(btn);
          }
        });
      }, { rootMargin: '600px' });
      observePagination();
    }
  }

  window.addEventListener('popstate', function () { render(window.location.href, false); });
})();
